// Gated by role NAME, not id: role rows created by hand per environment have no
// stable numeric id (unlike the legacy id-based checks below). Name is the
// stable identifier, and it is compared lowercased because the row's casing is
// not guaranteed to match between local, staging and prod.
const ROLE_NAMES = {
    WELCOME_CALL_COACH: 'welcome call coach',
};

const userIsResumeReviewer = (user) => {
    return user?.role?.id == 4;
};

const userIsCoach = (user) => {
    return user?.role?.id === 3 || (user?.role?.id === 5 && user?.coach);
};

const userIsAdmin = (user) => {
    return user?.role?.id === 5;
};

const userIsTaskmaster = (user) => {
    return user?.role?.id === 38;
};

const userIsWelcomeCallCoach = (user) => {
    return user?.role?.name?.toLowerCase() === ROLE_NAMES.WELCOME_CALL_COACH;
};

// PERMISSION — "may this user open the resumes tab and review a resume?".
//
// Deliberately separate from userIsResumeReviewer, which is the ASSIGNEE
// identity used to scope a resume list to "my assignments". A welcome call
// coach may review resumes but holds no resume-reviewer record, so scoping on
// them would silently produce an empty list. Gate access on this predicate and
// leave assignment scoping on userIsResumeReviewer.
const userCanReviewResumes = (user) => {
    return userIsResumeReviewer(user) || userIsWelcomeCallCoach(user);
};

// PERMISSION — "may this user open the welcome calls page?".
//
// Deliberately separate from userIsWelcomeCallCoach, which is the ASSIGNEE
// identity the backend uses to scope the list to "my calls". An admin holds no
// welcome-call-coach record, so scoping on them would produce an empty list;
// they see every call instead (ENG-366). Gate access on this predicate and
// leave assignment scoping on userIsWelcomeCallCoach.
const userCanViewWelcomeCalls = (user) => {
    return userIsWelcomeCallCoach(user) || userIsAdmin(user);
};

export {
    userIsResumeReviewer,
    userIsCoach,
    userIsAdmin,
    userIsTaskmaster,
    userIsWelcomeCallCoach,
    userCanReviewResumes,
    userCanViewWelcomeCalls,
};
